import { render, staticRenderFns } from "./IconMpv.vue?vue&type=template&id=010bbbe8"
import script from "./IconMpv.vue?vue&type=script&lang=js"
export * from "./IconMpv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports